import type { ActionResult, Loading } from "common/components/types";
import { LOADING } from "common/components/types";
import type { UseWeather } from "hooks/use-weather";
import * as React from "react";

import * as Style from "./local-time-style";

interface LocalTimeProps {
    hideCity: boolean;
    onClick?: () => Promise<ActionResult | undefined>;
    weather: UseWeather;
}

export const LocalTime: React.FunctionComponent<LocalTimeProps> = p => {
    const { hideCity, onClick, weather: weatherHook } = p;
    const { weather } = weatherHook;

    const [localTime, setLocalTime] = React.useState<Date | Loading | undefined>(LOADING);

    React.useEffect(() => {
        if (weather === LOADING) return;
        if (weather === undefined) {
            setLocalTime(undefined);
            return;
        }

        const now = Date.now();
        const date = new Date();
        const calculateTime = () => {
            const zone = date.getTimezoneOffset() * 60;
            const zoneDiff = weather.timezone + zone;
            const time = new Date(now + zoneDiff * 1000);
            setLocalTime(time);
        };

        const interval = setInterval(calculateTime, 1000 - (now % 1000));
        if (localTime === LOADING) {
            calculateTime();
        }

        return () => clearInterval(interval);
    }, [localTime, weather]);

    if (weather === LOADING || localTime === LOADING) {
        return (
            <Style.Wrapper>
                <Style.Sub>Loading time...</Style.Sub>
            </Style.Wrapper>
        );
    }

    if (weather === undefined || localTime === undefined) {
        return (
            <Style.Wrapper>
                <Style.Sub>Could not get timezone info.</Style.Sub>
            </Style.Wrapper>
        );
    }

    // This is supposed to generate a nice locale-specific date/time string.
    // FIXME: I'm not sure it does.
    const mainText = localTime.toLocaleString();

    if (hideCity) {
        return (
            <Style.Wrapper onClick={onClick}>
                <Style.Main>{mainText}</Style.Main>
            </Style.Wrapper>
        );
    } else {
        const city = weather.name;
        const country = weather.sys.country;
        const subText = `${city}, ${country}`;
        return (
            <Style.Wrapper onClick={onClick}>
                <Style.Main>{mainText}</Style.Main>
                <Style.Sub>{subText}</Style.Sub>
            </Style.Wrapper>
        );
    }
};
